import { render, staticRenderFns } from "./UserAccesRevoker.vue?vue&type=template&id=b204aa14&scoped=true"
import script from "./UserAccesRevoker.vue?vue&type=script&lang=js"
export * from "./UserAccesRevoker.vue?vue&type=script&lang=js"
import style0 from "./UserAccesRevoker.vue?vue&type=style&index=0&id=b204aa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b204aa14",
  null
  
)

export default component.exports